import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _entriesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/entries';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import 'core-js/modules/es.string.search.js';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import _parseFloat from '@babel/runtime-corejs3/core-js-stable/parse-float';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';

/**
 * Encode a value to a format compatible with a URL component.
 *
 * @param value - The value to be encoded
 * @returns A URI encoded value
 */
function encodeValue(value) {
  let encodedValue;
  if (typeof value === 'undefined') {
    encodedValue = 'undefined';
  } else if (value instanceof Date) {
    encodedValue = value.toISOString();
  } else {
    encodedValue = String(value);
  }
  return encodeURIComponent(encodedValue);
}
/**
 * Normalizes objects of different supported types into an array of key-value pairs.
 *
 * @param params - The parameters object to be normalized
 * @returns An array of key-value pairs
 */
function normalizeParams(params) {
  if (typeof FormData !== 'undefined' && params instanceof FormData) {
    return _Array$from(_entriesInstanceProperty(params).call(params));
  }
  return _Object$entries(params);
}
/**
 * Formats a JavaScript object into a valid URL search string.
 *
 * @remarks Given an empty object an empty string will be returned
 * @param params - The parameters object to format
 * @returns A valid URL search string with the values from the provided object
 * @public
 *
 * @example
 * ```javascript
 * import { formatUrlSearchParams } from '@thisisbud/url-utils'
 *
 * const result = formatUrlSearchParams({ foo: 'bar' })
 * // '?foo=bar'
 * ```
 */
function formatUrlSearchParams(params) {
  var _context, _context2;
  const search = _filterInstanceProperty(_context = _reduceInstanceProperty(_context2 = normalizeParams(params)).call(_context2, function (acc, [param, value]) {
    const encodedKey = encodeURIComponent(param);
    if (typeof value === 'undefined') {
      return acc;
    }
    // Handle arrays
    if (_Array$isArray(value)) {
      _forEachInstanceProperty(value).call(value, function (valueElement) {
        acc.push(`${encodedKey}=${encodeValue(valueElement)}`);
      });
      // Handle single values
    } else {
      acc.push(`${encodedKey}=${encodeValue(value)}`);
    }
    return acc;
  }, [])).call(_context, function (part) {
    return part !== '';
  }).join('&');
  return search ? `?${search}` : search;
}

const colonSuffixRegEx = /:$/;
const hashPrefixRegEx = /^#/;
const defaultPortsMap = {
  'ftp:': '21',
  'http:': '80',
  'https:': '443',
  'ws:': '80',
  'wss:': '443' // eslint-disable-line @typescript-eslint/naming-convention
};
/**
 * Normalize a URL protocol value.
 *
 * @param protocol - A protocol value to normalize
 * @returns The normalized protocol value suffixed with `:`
 */
function normalizeProtocol(protocol = '') {
  const normalizedProtocol = protocol.replace(colonSuffixRegEx, '');
  if (!normalizedProtocol) {
    return '';
  }
  return `${normalizedProtocol}:`;
}
/**
 * Normalize a URL hash value.
 *
 * @param hash - A hash value to normalize
 * @returns The normalized hash value with the `#` prefix removed
 */
function normalizeHash(hash = '') {
  return hash.replace(hashPrefixRegEx, '');
}
/**
 * Normalize a URL post value.
 *
 * @remarks If the port given is the default for the given protocol, an empty string will be returned
 * @param port - A port value to normalize
 * @param protocol - A protocol value to use for evaluating the default port
 * @returns The normalized port value
 */
function normalizePort(port = '', protocol) {
  if (port === '') {
    return '';
  } else if (typeof protocol !== 'string') {
    return port;
  }
  const normalizedProtocol = normalizeProtocol(protocol);
  if (normalizedProtocol === 'file:' || defaultPortsMap[normalizedProtocol] === port) {
    return '';
  }
  return port;
}

const slashPrefixRegEx = /^\//;
/**
 * Format the protocol part of a URL.
 *
 * @param url - A URL descriptor
 * @returns The protocol part of a URL including the `//` suffix
 */
function formatProtocolPart(url) {
  const protocol = normalizeProtocol(url.protocol);
  return `${protocol}//`;
}
/**
 * Format the authentication part of a URL.
 *
 * @remarks An empty string is returned if there is no username defined
 * @param url - A URL descriptor
 * @returns The authentication part of a URL including the `@` suffix
 */
function formatAuthPart(url) {
  const {
    username,
    password
  } = url;
  if (typeof username === 'undefined' || !username) {
    return '';
  }
  const usernamePart = encodeURIComponent(username);
  const passwordPart = typeof password !== 'undefined' && password ? `:${encodeURIComponent(password)}` : '';
  return `${usernamePart}${passwordPart}@`;
}
/**
 * Format the port part of a URL.
 *
 * @remarks An empty string is returned if there is no port defined
 * @remarks An emtpy string is returned if the port number matches the default for the protocol defined
 * @param url - A URL descriptor
 * @returns The port part of a URL including the `:` prefix
 */
function formatPortPart(url) {
  const {
    protocol,
    port
  } = url;
  const normalizedPort = normalizePort(port, protocol);
  if (!normalizedPort) {
    return '';
  }
  return `:${normalizedPort}`;
}
/**
 * Format the origin part of a URL.
 *
 * @remarks An empty string is returned if there is no hostname defined
 * @param url - A URL descriptor
 * @returns The origin part of a URL including the protocol, authorization, hostname and port
 */
function formatOriginPart(url) {
  const protocolPart = formatProtocolPart(url);
  const authPart = formatAuthPart(url);
  const portPart = formatPortPart(url);
  const {
    hostname
  } = url;
  if (typeof hostname !== 'string') {
    return '';
  }
  return `${protocolPart}${authPart}${hostname}${portPart}`;
}
/**
 * Format the pathname part of a URL.
 *
 * @param url - A URL descriptor
 * @returns The pathname part of a URL including the `/` prefix
 */
function formatPathnamePart(url) {
  const {
    pathname = ''
  } = url;
  const normalizedPathname = pathname.replace(slashPrefixRegEx, '');
  return `/${normalizedPathname}`;
}
/**
 * Formats the search part of a URL.
 *
 * @remarks An empty string is returned if there are no search parameters defined
 * @param url - A URL descriptor
 * @returns The search part of a URL including the `?` prefix
 */
function formatSearchPart(url) {
  const {
    searchParams = {}
  } = url;
  return formatUrlSearchParams(searchParams);
}
/**
 * Format the hash part of a URL.
 *
 * @remarks An empty string is returned if the hash has no value
 * @param url - A URL descriptor
 * @returns The hash part of a URL including the `#` prefix
 */
function formatHashPart(url) {
  const normalizedHash = normalizeHash(url.hash);
  if (!normalizedHash) {
    return '';
  }
  return `#${encodeURIComponent(normalizedHash)}`;
}
/**
 * Formats a URL string from a URL descriptor object.
 *
 * @param url - A URL descriptor
 * @returns A fully formed URL
 * @public
 *
 * @example
 * ```javascript
 * import { formatUrl } from '@thisisbud/url-utils'
 *
 * const result = formatUrl({
 *   hash: 'foobar',
 *   hostname: 'www.thisisbud.com',
 *   password: 'password',
 *   pathname: '/foobar',
 *   port: '3600',
 *   protocol: 'https:',
 *   searchParams: { foo: 'barb' },
 *   username: 'user',
 * })
 * // 'https://user:password@www.thisisbud.com:3600/foobar?foo=bar#foobar'
 * ```
 */
function formatUrl(url) {
  const originPart = formatOriginPart(url);
  const pathnamePart = formatPathnamePart(url);
  const searchPart = formatSearchPart(url);
  const hashPart = formatHashPart(url);
  return `${originPart}${pathnamePart}${searchPart}${hashPart}`;
}

const numberRegEx = /^\d+(\.\d+)?$/;
const dateRegEx = /^(19|20)[0-9][0-9]-(0[0-9]|1[0-2])-(0[1-9]|([12][0-9]|3[01]))T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]\.\d{3}Z$/;
/**
 * Parses a URL search string into a JavaScript object.
 *
 * @remarks Numbers, booleans, dates in simplified extended ISO format, null and undefined will be automatically cast into their value types
 * @param search - The URL search string to parse
 * @returns An object with the parsed parameters
 * @public
 *
 * @example
 * ```javascript
 * import { parseUrlSearchParams } from '@thisisbud/url-utils'
 *
 * const result = parseUrlSearchParams('?foo=bar')
 * // { foo: bar }
 * ```
 */
function parseUrlSearchParams(search) {
  const normalizedSearch = search.replace(/^\?/, '');
  if (normalizedSearch === '') {
    return {};
  }
  const parts = normalizedSearch.split('&');
  const output = {};
  _forEachInstanceProperty(parts).call(parts, function (part) {
    const [key, value] = part.split('=');
    const decodedKey = decodeURIComponent(key);
    let decodedValue = decodeURIComponent(value);
    if (decodedValue === 'true') {
      decodedValue = true;
    } else if (decodedValue === 'false') {
      decodedValue = false;
    } else if (numberRegEx.test(decodedValue)) {
      decodedValue = _parseFloat(decodedValue);
    } else if (dateRegEx.test(decodedValue)) {
      decodedValue = new Date(decodedValue);
    } else if (decodedValue === 'null') {
      decodedValue = null;
    } else if (decodedValue === 'undefined') {
      decodedValue = undefined;
    }
    if (output.hasOwnProperty(decodedKey)) {
      if (_Array$isArray(output[decodedKey])) {
        output[decodedKey].push(decodedValue);
      } else {
        output[decodedKey] = [output[decodedKey], decodedValue];
      }
    } else {
      output[decodedKey] = decodedValue;
    }
  });
  return output;
}

/**
 * Patch a URL descriptor parsed in a webkit browser version with a known URL bug.
 *
 * @see https://bugs.chromium.org/p/chromium/issues/detail?id=869291
 * @param descriptor - The incorrectly parsed URL descriptor
 */
function patchParsedWebkitUrl(descriptor) {
  const helper = new _URL(`https:${descriptor.pathname}`);
  descriptor.hostname = helper.hostname;
  descriptor.password = helper.password;
  descriptor.pathname = helper.pathname;
  descriptor.port = normalizePort(helper.port);
  descriptor.username = helper.username;
}
/**
 * Parses a URL string into a URL descriptor object.
 *
 * @param url - The URL to parse
 * @returns A URL descriptor object that can be used to reconstruct the URL
 * @public
 *
 * @example
 * ```javascript
 * import { parseUrl } from '@thisisbud/url-utils'
 *
 * const result = parseUrl('https://www.thisisbud.com:3600/#foobar')
 * // {
 * //   hash: 'foobar',
 * //   hostname: 'www.thisisbud.com',
 * //   password: '',
 * //   pathname: '/',
 * //   port: '3600',
 * //   protocol: 'https:',
 * //   searchParams: { },
 * //   username: '',
 * // }
 * ```
 */
function parseUrl(url) {
  var _context;
  const parsed = new _URL(url);
  const output = {
    hash: normalizeHash(parsed.hash),
    hostname: parsed.hostname,
    password: parsed.password,
    pathname: parsed.pathname,
    port: normalizePort(parsed.port),
    protocol: normalizeProtocol(parsed.protocol),
    searchParams: parseUrlSearchParams(parsed.search),
    username: parsed.username
  };
  // Handle a bug when parsing custom protocol URLs in webkit browsers, see https://bugs.chromium.org/p/chromium/issues/detail?id=869291
  if (output.hostname === '' && _startsWithInstanceProperty(_context = output.pathname).call(_context, '//')) {
    patchParsedWebkitUrl(output);
  }
  return output;
}

/**
 * Appends search parameters to an existing URL without removing existing search parameters or other URL parts.
 *
 * @param url - A URL to which the search parameters should be appended
 * @param searchParams - An object with search parameters to append
 * @returns The given URL with the given search parameters appended
 * @public
 *
 * @example
 * ```javascript
 * import { appendUrlSearchParams } from '@thisisbud/url-utils'
 *
 * const result = appendUrlSearchParams('https://www.thisisbud.com/?foo=true', { bar: true })
 * // 'https://www.thisisbud.com/?foo=true&bar=true'
 * ```
 */
function appendUrlSearchParams(url, searchParams) {
  const parsedUrl = parseUrl(url);
  return formatUrl(_objectSpread(_objectSpread({}, parsedUrl), {}, {
    searchParams: _objectSpread(_objectSpread({}, parsedUrl.searchParams), searchParams)
  }));
}

const leadingSlashRegEx = /^\//;
const trailingSlashRegEx = /\/$/;
/**
 * Joins all given path segments together and normalizes the resulting path.
 *
 * @param paths - A sequence of path segments
 * @returns The normalized resulting path
 * @public
 *
 * @example
 * ```javascript
 * import { joinUrlPaths } from '@thisisbud/url-utils'
 *
 * const result = joinUrlPaths('foo', 'bar')
 * // 'foo/bar'
 * ```
 */
function joinUrlPaths(...paths) {
  var _context;
  let isRootPath = null;
  const output = _mapInstanceProperty(_context = _filterInstanceProperty(paths).call(paths, function (path) {
    if (path !== '' && isRootPath === null) {
      if (_startsWithInstanceProperty(path).call(path, '/')) {
        isRootPath = true;
      } else {
        isRootPath = false;
      }
    }
    return path !== '' && path !== '/';
  })).call(_context, function (path, index) {
    if (index !== 0) {
      return path.replace(trailingSlashRegEx, '').replace(leadingSlashRegEx, '');
    }
    return path.replace(trailingSlashRegEx, '');
  }).join('/');
  if (isRootPath === true && !_startsWithInstanceProperty(output).call(output, '/')) {
    // eslint-disable-line @typescript-eslint/no-unnecessary-condition
    return `/${output}`;
  }
  return output;
}

export { appendUrlSearchParams, formatUrl, formatUrlSearchParams, joinUrlPaths, parseUrl, parseUrlSearchParams };
